import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationVaultAuthorize = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
